import { DateRangeParamType } from '@/Api';
import { DateFormatType, OrderStatusFilter } from '@/Enums';
import { RootState } from '@/Redux/RootReducer';
import { countryTypeUtils } from '@/Utils/CountryTypesUtils';
import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';

const purchasesPage = (state: RootState) => state.purchasesPage;

const translation = (state: RootState) => state.global.translation;

const selectedPurchase = createSelector(purchasesPage, (state) => state.selectedPurchase);

const selectedPurchases = createSelector(purchasesPage, (state) => state.selectedPurchases);

const selectedPurchasesIds = createSelector(selectedPurchases, (state) => state.map((sale) => sale.id));

const newPurchasesCount = createSelector(purchasesPage, (state) => state.newPurchasesCount);

const updatedPurchasesExists = createSelector(
  purchasesPage,
  (state) => state.updatedPurchasesExists || state.newPurchasesCount > 0,
);

const purchases = createSelector([purchasesPage, translation], (purchasesPage, translation) => {
  return (
    purchasesPage.purchases.map((purchase) => ({
      ...purchase,
      returnCountryName: countryTypeUtils.getCountryNameByCountryCode(purchase.returnCountryCode, translation),
      invoiceCountryName: countryTypeUtils.getCountryNameByCountryCode(purchase.invoiceCountryCode, translation),
      shippingCountryName: countryTypeUtils.getCountryNameByCountryCode(purchase.shippingCountryCode, translation),
      originalShippingCountryName: countryTypeUtils.getCountryNameByCountryCode(
        purchase.originalShippingCountryCode,
        translation,
      ),
    })) || []
  );
});

const orderFilters = createSelector(
  purchasesPage,
  (state) =>
    state.orderFilters ?? {
      mpAccountIds: [],
      orderStatusFilter: OrderStatusFilter.PaidNotReceived,
      dateRange: {
        rangeType: DateRangeParamType.CreationTime,
        timeFrom: moment().subtract(29, 'days').startOf('day').format(DateFormatType.LOCAL_DATE_TIME),
        timeTo: moment().endOf('day').format(DateFormatType.LOCAL_DATE_TIME),
      },
    },
);

export const purchasesPageSelectors = {
  purchases,
  selectedPurchase,
  selectedPurchases,
  selectedPurchasesIds,
  orderFilters,
  newPurchasesCount,
  updatedPurchasesExists,
};
